export function areSetsEqual<T>(setA: Set<T>, setB: Set<T>): boolean {
    if (setA.size !== setB.size) {
        return false;
    }

    for (const a of setA) {
        if (!setB.has(a)) {
            return false;
        }
    }

    return true;
}
